import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between"
};
const _hoisted_2 = {
  class: "flex items-center text-sm"
};
const _hoisted_3 = {
  class: "max-h-[150px] py-1 bg-main-5 shadow-weak_material rounded overflow-y-auto scroll-main text-xs",
  "focus-group": "calendar-button"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "max-h-[150px] py-1 bg-main-5 shadow-weak_material rounded overflow-y-auto scroll-main text-xs",
  "focus-group": "calendar-button"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "grid grid-cols-7 grow text-main-100 text-xs select-none"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button");
  const _component_FloatingElement = _resolveComponent("FloatingElement");
  const _component_CalendarDay = _resolveComponent("CalendarDay");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-[300px] flex flex-col gap-8 text-main-100", {
      'bg-main-5 p-3 rounded-xl shadow-material': this.defaultStyle
    }]),
    tabindex: "0"
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Button, {
    size: "xs",
    variant: "default",
    icon: "icon-chevron-left",
    rounded: true,
    onClick: _cache[0] || (_cache[0] = $event => this.ToDate({
      monthly: -1
    }))
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "cursor-pointer py-0.5 px-1 rounded hover:bg-main-10",
    onClick: _cache[1] || (_cache[1] = $event => {
      _ctx.showMonthSelector = !_ctx.showMonthSelector;
      _ctx.showYearSelector = false;
    }),
    tabindex: "0",
    onFocus: _cache[2] || (_cache[2] = $event => this.$handleFocusGroup(() => _ctx.showYearSelector = _ctx.showMonthSelector = false)),
    "focus-group": "calendar-button"
  }, [_createTextVNode(_toDisplayString(this.$st('utils.months.' + this.currentCalendarDate?.getMonth())) + " ", 1), _ctx.showMonthSelector ? (_openBlock(), _createBlock(_component_FloatingElement, {
    key: 0,
    position: {
      top: 4,
      left: 0,
      translateY: true
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (month, index) => {
      return _createElementVNode("div", {
        key: month,
        class: "py-1 px-3 hover:bg-main-10 cursor-pointer",
        onClick: $event => this.ToDate({
          month: index
        })
      }, _toDisplayString(this.$st('utils.months.' + index)), 9, _hoisted_4);
    }), 64))])]),
    _: 1
  })) : _createCommentVNode("", true)], 32), _createElementVNode("div", {
    class: "cursor-pointer py-0.5 px-2 rounded hover:bg-main-10",
    onClick: _cache[3] || (_cache[3] = $event => {
      _ctx.showYearSelector = !_ctx.showYearSelector;
      _ctx.showMonthSelector = false;
    }),
    tabindex: "0",
    onFocus: _cache[4] || (_cache[4] = $event => this.$handleFocusGroup(() => _ctx.showYearSelector = _ctx.showMonthSelector = false)),
    "focus-group": "calendar-button"
  }, [_createTextVNode(_toDisplayString(this.currentCalendarDate?.getFullYear()) + " ", 1), _ctx.showYearSelector ? (_openBlock(), _createBlock(_component_FloatingElement, {
    key: 0,
    position: {
      top: 4,
      left: 0,
      translateY: true
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.years, year => {
      return _openBlock(), _createElementBlock("div", {
        key: year,
        onClick: $event => this.ToDate({
          year
        }),
        class: "py-1 px-3 hover:bg-main-10 cursor-pointer"
      }, _toDisplayString(year), 9, _hoisted_6);
    }), 128))])]),
    _: 1
  })) : _createCommentVNode("", true)], 32)]), _createVNode(_component_Button, {
    size: "xs",
    variant: "default",
    icon: "icon-chevron-right",
    rounded: true,
    onClick: _cache[5] || (_cache[5] = $event => this.ToDate({
      monthly: 1
    }))
  })]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.weekdays, weekday => {
    return _openBlock(), _createElementBlock("div", {
      key: weekday,
      class: "flex items-center justify-center text-main-50 mb-3"
    }, _toDisplayString(weekday), 1);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.currentCalendarSchema?.previousDays, day => {
    return _openBlock(), _createBlock(_component_CalendarDay, {
      key: day,
      day: day,
      state: this.DateStateHandler(day, -1),
      events: this.GetDayEvents(day, -1),
      adjacent: true,
      onClick: $event => this.OnClickDay(day, -1)
    }, null, 8, ["day", "state", "events", "onClick"]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.currentCalendarSchema?.days, day => {
    return _openBlock(), _createBlock(_component_CalendarDay, {
      key: day,
      day: day,
      state: this.DateStateHandler(day, 0),
      events: this.GetDayEvents(day, 0),
      onClick: $event => this.OnClickDay(day, 0)
    }, null, 8, ["day", "state", "events", "onClick"]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.currentCalendarSchema?.nextDays, day => {
    return _openBlock(), _createBlock(_component_CalendarDay, {
      key: day,
      day: day,
      state: this.DateStateHandler(day, 1),
      events: this.GetDayEvents(day, 1),
      adjacent: true,
      onClick: $event => this.OnClickDay(day, 1)
    }, null, 8, ["day", "state", "events", "onClick"]);
  }), 128))])], 2);
}